/**
 * External dependencies.
 */
import React from "react";

/**
 * Internal dependencies
 */
import Markdown from "components/markdown/markdown";
import ProgressBar from "components/progress-bar/progress-bar";
import Share from "components/share/share";

interface ArticleProps {
  content: String;
}

const Article: React.FC<ArticleProps> = ({ content }) => {
  return (
    <div className="article">
      <ProgressBar />

      <div className="container">
        <div className="article__inner">
          {content &&
            <div className="article__content">
              <Markdown content={content} />
            </div>
          }
        </div>
      </div>

      <Share />
    </div>
  );
};

export default Article;
